import { useState, useEffect } from 'react';
import { 
  Globe, 
  Smartphone, 
  Apple, 
  Briefcase, 
  Building2, 
  Mail,
  Facebook,
  Twitter,
  Instagram,
  Linkedin
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function LinktreePage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // ENLACES PRINCIPALES - ACTUALIZADOS CON LAS URLS DEL TUTOR
  const links = [
    {
      title: 'Lingua2 website',
      icon: Globe,
      url: 'https://www.languageexchanges.com',
      description: 'Visit our main website',
    },
    {
      title: 'Lingua2 Android app',
      icon: Smartphone,
      url: '', // dejar en blanco por ahora
      description: 'Download for Android',
    },
    {
      title: 'Lingua2 iOS app',
      icon: Apple,
      url: '', // dejar en blanco por ahora
      description: 'Download for iPhone',
    },
    {
      title: 'Lingua2 language jobs',
      icon: Briefcase,
      url: '', // dejar en blanco por ahora
      description: 'Explore career opportunities',
    },
    {
      title: 'Solutions for organizations',
      icon: Building2,
      url: 'https://www.lingua2.net',
      description: 'Enterprise language solutions',
    },
    {
      title: 'Contact',
      icon: Mail,
      url: '', // dejar en blanco por ahora
      description: 'Get in touch with us',
    },
  ];

  // REDES SOCIALES - ACTUALIZADAS CON URLS REALES, YOUTUBE ELIMINADO
  const socialLinks = [
    { icon: Facebook, url: 'https://www.facebook.com/lingua2web/', label: 'Facebook' },
    { icon: Twitter, url: 'https://twitter.com/lingua2', label: 'Twitter' },
    { icon: Instagram, url: 'https://www.instagram.com/lingua2_', label: 'Instagram' },
    { icon: Linkedin, url: '', label: 'LinkedIn' }, // dejar en blanco por ahora
  ];

  const handleLinkClick = (link) => {
    // Si la URL está vacía, no abrimos nada y mostramos mensaje informativo
    if (!link.url) {
      toast.info(`${link.title} coming soon!`, {
        description: 'This link will be available soon.',
      });
      return;
    }
    // ABRIR EN LA MISMA PESTAÑA (sin _blank)
    window.location.href = link.url;
  };

  const handleSocialClick = (social) => {
    if (!social.url) {
      toast.info(`${social.label} coming soon!`, {
        description: 'This link will be available soon.',
      });
      return;
    }
    // ABRIR EN LA MISMA PESTAÑA (sin _blank)
    window.location.href = social.url;
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-xl">
        {/* Logo/Brand */}
        <div className={`text-center mb-8 lg:mb-12 ${
          isVisible ? 'animate-fade-in' : 'opacity-0'
        }`}>
          <div className="inline-block mb-4">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold">
              <span className="text-primary">Lingua</span>
              <span className="text-foreground">2</span>
            </h1>
          </div>
          <p className="text-base sm:text-lg text-muted-foreground max-w-lg mx-auto px-4">
            Language Exchange Community for Individuals, Teachers and Organizations
          </p>
        </div>

        {/* Links */}
        <div className="space-y-4 mb-8 lg:mb-12">
          {links.map((link, index) => {
            const Icon = link.icon;
            return (
              <Button
                key={index}
                onClick={() => handleLinkClick(link)}
                className={`w-full h-auto py-4 px-6 bg-primary hover:bg-primary-light border-2 border-primary hover:border-primary-light text-primary-foreground transition-all duration-300 hover:scale-[1.02] hover:shadow-lg rounded-xl group ${
                  isVisible ? 'animate-slide-up' : 'opacity-0'
                }`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-lg bg-white/20 group-hover:bg-white/30 flex items-center justify-center transition-colors duration-300">
                      <Icon className="h-6 w-6 text-primary-foreground transition-colors duration-300" />
                    </div>
                    <span className="text-base sm:text-lg font-semibold">{link.title}</span>
                  </div>
                  <svg
                    className="w-5 h-5 text-primary-foreground transition-colors duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </Button>
            );
          })}
        </div>

        {/* Social Links - SIN YOUTUBE */}
        <div className={`flex items-center justify-center gap-4 mb-8 ${
          isVisible ? 'animate-fade-in' : 'opacity-0'
        }`} style={{ animationDelay: '0.6s' }}>
          {socialLinks.map((social, index) => {
            const Icon = social.icon;
            return (
              <a
                key={index}
                href={social.url || '#'}
                aria-label={social.label}
                className="w-12 h-12 rounded-full bg-muted hover:bg-primary border-2 border-border hover:border-primary flex items-center justify-center transition-all duration-300 hover:scale-110 group"
                onClick={(e) => {
                  e.preventDefault();
                  handleSocialClick(social);
                }}
              >
                <Icon className="h-5 w-5 text-muted-foreground group-hover:text-primary-foreground transition-colors duration-300" />
              </a>
            );
          })}
        </div>

        {/* Footer */}
        <div className={`text-center text-sm text-muted-foreground ${
          isVisible ? 'animate-fade-in' : 'opacity-0'
        }`} style={{ animationDelay: '0.7s' }}>
          <p>© {new Date().getFullYear()} Lingua2. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}